// extracted by mini-css-extract-plugin
module.exports = {"accordion":"X_n","active":"X_dq","icon":"X_cy"};